export default "__VITE_ASSET__HViXGGNz__"